import { queryOptions } from "@tanstack/react-query";
import type { ToolResponse } from "@/app/tools/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import { HIDDEN_TOOLKITS } from "@/lib/const";
import type { OrgProjectScope } from "@/lib/resource-context";
import { serversKeys } from "./query-keys";

const fetchServerTools = async (options: {
  client: ApiClient;
  id: string;
}): Promise<ToolResponse> => {
  const { client, id } = options;
  const { data } = await client.get<ToolResponse>(`/workers/${id}/tools`, {
    params: { limit: 25_000 },
  });

  const filteredItems = data.items.filter(
    (tool) => !HIDDEN_TOOLKITS.has((tool.toolkit?.name || "").toLowerCase())
  );

  return {
    ...data,
    items: filteredItems,
    total_count: filteredItems.length,
  };
};

export const getServerToolsQueryOptions = ({
  id,
  binding = "project",
  scope,
}: {
  id: string;
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<ToolResponse>({
    queryKey: serversKeys.serverTools({ serverId: id, binding, scope }),
    queryFn: () => fetchServerTools({ client, id }),
  });
};
